import PropTypes from "prop-types";
import { Navigate } from "react-router-dom";
import useAuth from "../hooks/useAuth";

OfficerGuard.propTypes = {
  children: PropTypes.node,
};

export default function OfficerGuard({ children }) {
  const { user, role } = useAuth();

  if (!user || role !== "officer") {
    return <Navigate to={"/login"} />;
  }

  return <>{children}</>;
}
